import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const partners = ["Google", "OpenAI", "Claude", "Second Front", "Moveworks · ServiceNow"];

export const Partners = () => (
  <section id="partners" data-testid="partners-section" className="py-24 md:py-32 border-t border-black/10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ type: "spring", stiffness: 60, damping: 18 }}
        className="max-w-3xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#0891B2] mb-4">Partners</p>
        <h2 className="text-3xl sm:text-4xl font-heading font-bold tracking-tight text-zinc-950">
          The best of commercial tech, delivered to the mission
        </h2>
        <p className="mt-6 text-[19px] leading-relaxed text-zinc-600">
          Harris Holt brings the best of commercial tech to government mission
          operations. From AI agents to software delivery to secure cloud, our
          tech partnerships help customers reduce the time and cost it takes to
          field operational deployments while improving security posture — even
          in classified, air-gapped environments.
        </p>
      </motion.div>
    </div>

    <div data-testid="partners-marquee" className="mt-16 border-y border-black/10 py-10">
      <Marquee speed={40} gradient={false} pauseOnHover>
        {partners.map((p) => (
          <span
            key={p}
            data-testid={`partner-${p.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="mx-12 text-3xl md:text-5xl font-heading font-black tracking-tight text-zinc-300 hover:text-zinc-950 transition-colors cursor-default whitespace-nowrap"
          >
            {p}
            <span className="ml-24 text-[#0891B2] text-2xl align-middle">/</span>
          </span>
        ))}
      </Marquee>
    </div>
  </section>
);
